import { ICellRendererParams } from '@ag-grid-community/core'
import { Command } from '../model/job.model'

export const commandDataCellRenderer = (
  params: ICellRendererParams,
): string => {
  const data = params.data as Command
  if (data != null) {
    return JSON.stringify(data.data)
  }

  return ''
}
